import { VIDEOS, vimeoEmbedUrl } from "@/config/site";
import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

export function VideoSection() {
  const { t, lang } = useLanding();
  const clips = VIDEOS[lang] || VIDEOS.en;
  return (
    <InteractiveSection className="section section-dark" id="watch" data-testid="video-section">
      <MotionBg variant="aurora" dots={3} />
      <div className="container video-wrap">
        <Reveal>
          <p className="eyebrow"><span className="eyebrow-no">05</span>{t.video.eyebrow}</p>
          <h2>{t.video.title}</h2>
          <p className="lead">{t.video.lead}</p>
          <p className="video-note" data-testid="video-physical-note">{t.video.note}</p>
          <div className="video-points">
            {t.video.points.map((point) => (
              <div className="video-point" key={point}>{point}</div>
            ))}
          </div>
          <a className="btn btn-gold" href="#register" data-testid="video-cta">
            {t.video.button} <span className="arrow">→</span>
          </a>
        </Reveal>
        <div className="video-media">
          <Reveal className="video-frame" delay={0.1}>
            <div className={`video-grid ${clips.length === 1 ? "single" : ""}`} data-testid="video-grid">
              {clips.map((clip, i) => (
                <figure className="video-card" key={clip.id} data-testid={`video-card-${i}`}>
                  <div className="video-aspect portrait">
                    <iframe
                      src={vimeoEmbedUrl(clip)}
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      title={clip.title}
                      loading="lazy"
                      data-testid={`webinar-video-${i}`}
                    />
                  </div>
                  <figcaption className="video-card-caption">
                    <span>{clip.caption}</span>
                    <span>{clip.speaker}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
            <div className="video-caption">
              <span>{t.video.caption}</span>
              <span>Affinity Group</span>
            </div>
          </Reveal>
          {t.video.quotes?.length > 0 && (
          <Reveal delay={0.2}>
            <p className="video-quotes-title" data-testid="video-quotes-title">{t.video.quotesTitle}</p>
            <div className="video-quotes" data-testid="video-quotes">
              {t.video.quotes.map((q, i) => (
                <blockquote className="quote-card" key={q.who + i} data-testid={`video-quote-${i}`}>
                  <span className="quote-stars" aria-hidden="true">★★★★★</span>
                  <p className="quote-text">{q.text}</p>
                  <footer className="quote-who">{q.who}</footer>
                </blockquote>
              ))}
            </div>
          </Reveal>
          )}
        </div>
      </div>
    </InteractiveSection>
  );
}
